import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed bottom-5 right-5 z-10 flex h-[580px] w-10/12 max-w-md flex-col rounded-lg border bg-white text-sm shadow-lg md:w-full md:text-base" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "relative" }

import {
  computed,
  onMounted,
} from 'vue';
import ChatFooter from '@/components/ChatApp/ChatFooter.vue';
import ChatInterface from '@/components/ChatApp/ChatInterface.vue';
import ChatTitle from '@/components/ChatApp/ChatTitle.vue';
import AppNotification from '@/components/Helper/AppNotification.vue';
import FullContentButton from '@/components/Helper/FullContentButton.vue';
import CustomLoader1 from '@/components/Helper/Loader/CustomLoader1.vue';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatApp',
  emits: ["interface:close"],
  setup(__props, { emit: __emit }) {


const emits = __emit;

const authStore = useStore.auth;
const utilStore = useStore.util;

const notification = computed(() => utilStore.notification);
const isLeftNavigationMenuOn = computed(() => utilStore.isLeftNavigationMenuOn);

onMounted(async () => {
  authStore.getUser();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isLeftNavigationMenuOn.value)
        ? (_openBlock(), _createBlock(FullContentButton, {
            key: 0,
            class: "z-10",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(utilStore).isLeftNavigationMenuOn = !_unref(utilStore).isLeftNavigationMenuOn))
          }))
        : _createCommentVNode("", true),
      _createVNode(ChatTitle, {
        onClose: _cache[1] || (_cache[1] = ($event: any) => (emits('interface:close')))
      }),
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_3, [
          (notification.value)
            ? (_openBlock(), _createBlock(AppNotification, {
                key: 0,
                message: notification.value.message,
                type: notification.value.type,
                permanent: notification.value.permanent,
                onClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(utilStore).notification = undefined))
              }, null, 8, ["message", "type", "permanent"]))
            : _createCommentVNode("", true),
          (_unref(authStore).loading)
            ? (_openBlock(), _createBlock(CustomLoader1, {
                key: 1,
                class: "my-auto"
              }))
            : (_unref(authStore).userId)
              ? (_openBlock(), _createBlock(ChatInterface, {
                  key: 2,
                  class: _normalizeClass({ 'opacity-50': isLeftNavigationMenuOn.value })
                }, null, 8, ["class"]))
              : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(ChatFooter, { class: "absolute bottom-0 w-full" })
  ]))
}
}

})